import React from 'react';
import { getInstance as getBootstrap } from 'utils/bootstrap';

const NAMESPACE = 'grecaptcha';

/**
 * Adds the reCAPTCHA v2 script to the page, so it loads.
 *
 * @see https://developers.google.com/recaptcha/docs/display
 */
const loadRecaptchaScript = () => {
    const recaptchaGoogleCloudEnabled = getBootstrap().get('flags.recaptchaGoogleCloudEnabled') || false;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = recaptchaGoogleCloudEnabled
        ? 'https://www.google.com/recaptcha/enterprise.js?render=explicit'
        : 'https://www.google.com/recaptcha/api.js?render=explicit';
    script.defer = true;

    if (recaptchaGoogleCloudEnabled) {
        script.async = true;
    }

    if (!__TESTING__) {
        document.body.appendChild(script);
    }
};

let loadStarted = false;

/**
 * @param {React} Component
 * @return {React}
 */
export default function withAutoLoad(WrappedComponent) {
    return (props) => {
        if (!loadStarted && window[NAMESPACE] == null) {
            loadRecaptchaScript();
            loadStarted = true;
        }
        return <WrappedComponent {...props} />;
    };
}

export const hasLoadStarted = () => loadStarted;
export const resetLoadStarted = () => {
    if (__TESTING__) {
        loadStarted = false;
    }
};
